/* World of Mysore Pak theme layer: menu, quick add, videos, scroll reveal */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Toast ---------- */
  var toastEl = null;
  var toastTimer = null;

  function toast(message, linkText, linkHref) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'womp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    if (linkText && linkHref) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText;
      toastEl.appendChild(a);
    }
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 3200);
  }

  /* ---------- Cart count ---------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-womp-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
    document.querySelectorAll('[data-womp-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  /* ---------- Quick add ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-womp-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var title = btn.getAttribute('data-womp-title') || 'Item';
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-womp-add')), quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
          return res.json();
        });
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
        toast(title + ' added to cart. ', 'View cart', root + 'cart');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
        toast(msg);
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
      });
  });

  /* ---------- Mobile menu ---------- */
  var lastTrigger = null;

  function openDrawer(drawer, trigger) {
    lastTrigger = trigger || null;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var panel = drawer.querySelector('.womp-drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastTrigger) {
      lastTrigger.setAttribute('aria-expanded', 'false');
      lastTrigger.focus();
    }
    setTimeout(function () { drawer.hidden = true; }, 300);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-womp-nav-open]');
    if (opener) {
      var drawer = document.getElementById(opener.getAttribute('aria-controls'));
      if (drawer) openDrawer(drawer, opener);
      return;
    }
    var closer = event.target.closest('[data-womp-nav-close]');
    if (closer) {
      var open = closer.closest('[data-womp-drawer]');
      if (open) closeDrawer(open);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-womp-drawer].is-open');
    if (open) closeDrawer(open);
  });

  /* ---------- Videos: play only while on screen ---------- */
  var videoObserver = hasIO
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && !reduceMotion) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.15 })
    : null;

  function initVideos(scope) {
    (scope || document).querySelectorAll('.womp-hero__video, .womp-step__video').forEach(function (video) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      if (video.offsetParent === null) {
        video.removeAttribute('autoplay');
        video.preload = 'none';
        video.pause();
      }
      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
      }
      if (videoObserver) videoObserver.observe(video);
    });
  }

  /* ---------- Scroll reveal ---------- */
  var revealObserver = hasIO && !reduceMotion
    ? new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -60px 0px', threshold: 0.1 })
    : null;

  function initReveal(scope) {
    (scope || document).querySelectorAll('.womp-reveal:not(.is-revealed)').forEach(function (el) {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-revealed');
    });
  }

  /* ---------- Header shadow once the page scrolls ---------- */
  var headerEl = null;
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      if (!headerEl) headerEl = document.querySelector('[data-womp-header]');
      if (headerEl) headerEl.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  function init(scope) {
    onScroll();
    initVideos(scope);
    initReveal(scope);
  }

  window.wompReady = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor: re-run when a section is added or edited */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
